import { request } from '../../utils/request';

export const getConversationMessages = (
  conversationId: number,
  authToken: string,
  filters?: Record<string, string>
) => {
  const queries = new URLSearchParams({
    ...filters,
  });

  return request({
    method: 'GET',
    url: `/messaging/conversations/${conversationId}/messages?${queries.toString()}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
